import 'slick-carousel';
export default (function () {
  $('.js-carousel-slider').slick({
    rows: 0,
    slidesToShow: 2,
    slidesToScroll: 1,
    swipeToSlide: true,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 992,
      settings: {
        dots: true,
        arrows: false,
        slidesToShow: 2
      }
    }, {
      breakpoint: 600,
      settings: {
        dots: true,
        arrows: false,
        slidesToShow: 1
      }
    }]
  });
});